<template>
  <div class="h-100" style="min-height: 1px">
    <component :is="type + 'View'" v-if="type" ref="intervalView" />
  </div>
</template>
<script>
import PowerView from '../interval/power/View'
import GasView from '../interval/gas/View'

export default {
  components: {
    PowerView,
    GasView,
  },
  data() {
    return {
      type: this.$store.getters['energetic/getCurrentType'],
    }
  },
}
</script>
